import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ButtonProps } from "../../helpers/constants";
import PendingVouchersComponent from "./Pending";
import RedeemedVouchersComponent from "./Redeemed";
import CreateNewDiscountVoucherModalComponent from "../Modals/CreateNewDiscountVoucherModal";
import MeshBillButton from "../Items/Button/Index";
import MeshBillTabs from "../Items/Tabs";
// const MeshBillTabs = lazy(() => import("../Items/Tabs"));
// const PendingVouchersComponent = lazy(() => import("./Pending"));
// const RedeemedVouchersComponent = lazy(() => import("./Redeemed"));
// const MeshBillButton = lazy(() => import("../Items/Button/Index"));

// const CreateNewDiscountVoucherModalComponent = lazy(
//   () => import("../Modals/CreateNewDiscountVoucherModal")
// );
const ViewDiscountVouchersComponent = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const _activeTab = searchParams.get("activeTab") || 1;
  const [activeTab, setActiveTab] = useState<number>(Number(_activeTab));
  const [show, setShow] = useState<boolean>(false);
  const [tabs, setTabs] = useState<MeshBillTabItemsProp[]>([
    {
      text: "Unused Vouchers",
      isActive: true,
      id: 1,
    },
    {
      text: "Used Vouchers",
      isActive: false,
      id: 2,
    },
  ]);

  const showActiveComponent = (activeTab: number) => {
    switch (activeTab) {
      case 1:
        return <PendingVouchersComponent />;
      case 2:
        return <RedeemedVouchersComponent />;
    }
    return <>Hello</>;
  };
  const handleTabSwitch = (tabId: number) => {
    navigate(`/discount-vouchers?activeTab=${tabId}`);
  };
  useEffect(() => {
    setActiveTab(Number(_activeTab));
    const updatedItems = tabs.map((item) => ({
      ...item,
      isActive: item.id === Number(_activeTab),
    }));
    setTabs(updatedItems);
  }, [activeTab, _activeTab]);
  const handleClose = (isReload: boolean) => {
    setShow(false);
    if (isReload === true) {
      window.location.href = "/discount-vouchers?activeTab=1";
    }
  };
  return (
    <>
      {show === true && (
        <CreateNewDiscountVoucherModalComponent
          show={show}
          handleClose={handleClose}
        />
      )}

      <Row gutter={16}>
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "20px",
          }}
          span={24}
        >
          <MeshBillButton
            backgroundColor={ButtonProps.background.STANDARD}
            height={ButtonProps.height.STANDARD}
            width={ButtonProps.width.STANDARD}
            textColor={ButtonProps.color.STANDARD}
            onClick={() => {
              setShow(true);
            }}
            text="Generate Voucher"
          />
        </Col>

        <MeshBillTabs
          colSpan={12}
          tabs={tabs}
          handleTabSwitch={handleTabSwitch}
        />
      </Row>
      <Row style={{ marginTop: "20px" }}>{showActiveComponent(activeTab)}</Row>
    </>
  );
};
export default ViewDiscountVouchersComponent;
